import React, { useState, useEffect } from 'react';
import './TimingsPage.css';

import { PageTitle } from '../../../components';
import { prayerTimings } from '../../../constants';



const PrayerTimingTable = () => {
  // Sample data - in a real app, you'd fetch this from an API or database


  // State to store prayer times
  const [prayerTimes, setPrayerTimes] = useState([]);
  const [loading, setLoading] = useState(true);

  // Simulate fetching data (in a real app, you'd use an API call here)
  useEffect(() => {
    // This timeout simulates an API call delay
    const timer = setTimeout(() => {
      setPrayerTimes(prayerTimings);
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (

    <>
      {/* Page Title */}
      <PageTitle title={'Prayer Timings'} page={'Prayer Timings'} />

      <section className="prayer-timing-table">
        <div className="container">
          <div className="box-container">

            <div className="table-title">
              <h3 className="date">Date</h3>
              <h3>Fajr</h3>
              <h3>Sunrise</h3>
              <h3>Dhuhr</h3>
              <h3>Asr</h3>
              <h3>Magrib</h3>
              <h3>Isha</h3>
            </div>

            <div className="points">
              {loading ? (
                <div className="loading">Loading prayer times...</div>
              ) : (
                prayerTimes.map((time, index) => (
                  <div className="point-item" key={index}>
                    <div className="box date">
                      {time.date} <br /> {time.hijri}
                    </div>
                    <div className="box">{time.fajr}</div>
                    <div className="box">{time.sunrise}</div>
                    <div className="box">{time.dhuhr}</div>
                    <div className="box">{time.asr}</div>
                    <div className="box">{time.maghrib}</div>
                    <div className="box">{time.isha}</div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default PrayerTimingTable;